// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9112e903","239":"287ba4da","453":"09c4b261","455":"e973d290"}[chunkId] + ".chunk.js";
};